import { createStore } from '@stencil/store'
import Axios from 'axios'

import { IBookmark, ISlackChannel } from '../../bookmarks/types'

export type SlackIntegrationState = typeof SlackIntegrationStore.state
export type SlackChannel = { external_id: string; name: string }

export const SlackIntegrationStore = createStore({
  connectedTo: '',
  connectUrl: null as string,
  mappingUrl: null as string,
  channels: [] as SlackChannel[],
})

// Slack functions
export async function mapBookmarkToChannel(bookmark: IBookmark, channel: ISlackChannel = null) {
  if (bookmark.linkSlackChannelUrl) {
    bookmark.slack_channel = channel ? channel : null
    await Axios.put(bookmark.linkSlackChannelUrl, {
      slack_channel: { external_id: bookmark.slack_channel?.external_id },
    })
  }
}
